(ns ycweb.components.tables
  (:require
    [rum.core :as rum]
    [ycweb.util.core :as u]
    [ycweb.util.date :as ud]
    #?@(:cljs
        [[cljs-time.format :as format]
         [cljs-time.coerce :as coerce]])
    [ycweb.components.forms :as forms]
    [util.string :as str]
    [ycweb.app.dashboard.orders :as orders]
    [ycweb.app.dashboard.warehouse.common :as wh.cmn]
    [ycweb.weber.elements :as elm]))

(defn get-column-type-fn [column-type col row row-on-click options]
  (case column-type
    :date #(ud/format-date % (or (:dateformat col) "yyyy/MM/dd hh:mm"))
    :currency #(str "R" (u/number-format % 2))
    :tocurrency #(str "R" (u/currency-format % 2))
    :tohumancurrency #(str "R" (u/human-readable-currency %))
    :percentage #(str (u/number-format (or % 0) 2) "%")
    :barcode #(wh.cmn/barcode-text % "")
    :view-link
    (fn [view]
      [:a
       {:on-click (when row-on-click #(row-on-click row))}
       view])
    :link
    (fn [[view link]]
      [:a
       (merge
         (when (:redirect? options)
           {:target "_blank"})
         {:href link})
       view])
    :number #(if (:decimals col) (u/number-format % (:decimals col)) (u/number-format %))
    :img
    (fn [[public-id file-name specs]]
      [:img
       {:class (u/bem :image [:full])
        :src
        (u/cloudinary
          public-id
          (or
            specs
            {:h 128
             :q "auto"
             :f "auto"}))
        :alt file-name}])

    identity))

(rum/defcs table-raw <
  rum/reactive
  (rum/local {:sort-key nil :order :desc :filters {} :pagination {:page 0 :pagesize 10}} ::local)
  [s headers data {:keys [pagination? page-size row-on-click]}]
  #?(:cljs
     (let [local-atom (::local s)
           sort-key-atom (rum/cursor local-atom :sort-key)
           order-atom (rum/cursor local-atom :order)
           pagination-atom (rum/cursor local-atom :pagination)
           page-atom (rum/cursor pagination-atom :page)
           page-size-atom (rum/cursor pagination-atom :pagesize)
           _ (when page-size (reset! page-size-atom page-size))

           pagination (rum/react pagination-atom)

           filters-atom (rum/cursor local-atom :filters)
           filters (rum/react filters-atom)

           paging-fn
           (fn [data]
             (if pagination?
               (let [current-page (rum/react page-atom)]
                 (->>
                   data
                   (drop (* (:page pagination) (:pagesize pagination)))
                   (take (:pagesize pagination))))
               data))

           sorting-fn
           (fn [data]
             (if
               (rum/react sort-key-atom)
               (sort-by
                 (rum/react sort-key-atom)
                 (if
                   (= (rum/react order-atom) :desc)
                   u/desc
                   compare)
                 data)
               data))

           filtering-fn
           (fn [data]
             (if
               (not
                 (empty?
                   (remove nil?
                     (vals filters))))

               (filter
                 (fn [row]
                   (every?
                     (fn [fkey]
                       (let [cleaned-number
                             (str/trim
                               (apply
                                 str
                                 (rest (get filters fkey))))

                             row-value (get row fkey)

                             valid-numbers?
                             (and
                               (number? row-value)
                               (re-find #"^[0-9]\d*(\.\d+)?$" cleaned-number))

                             selected-operator
                             (case (first (get filters fkey))
                               \< <

                               \> >

                               \= =

                               false)]

                         (or
                           (str/includes?
                             (str/lower (str row-value))
                             (str/lower (str (get filters fkey))))
                           (when
                             (and valid-numbers? selected-operator)
                             (selected-operator
                               row-value
                               (js/parseInt
                                 cleaned-number))))))
                     (keys filters))) data)
               data))

           formatting-fn
           (partial
             map
             (fn [row]
               [:tr
                {:on-click (when row-on-click #(row-on-click row))}
                (map
                  (fn [{:keys [default type align-class style component-fn options] :as col}]
                    (let [val (get row (:key col))
                          typefn (get-column-type-fn type col row row-on-click options)]
                      [:td
                       {:class
                        [(cond
                           align-class
                           align-class

                           (or (= type :currency) (= type :number) (= type :tocurrency))
                           :u-text-right

                           (= type :date)
                           :u-text-center)]
                        :style (or style {})}
                       (cond
                         component-fn
                         (component-fn
                           (typefn val) row)

                         val
                         (typefn val)

                         :else
                         default)]))
                  headers)]))

           search-bars
           [(into
              [:tr.tablesorter-filter-row
               {:role "row"}]
              (map
                (fn [x]
                  [:td
                   (forms/input-raw "" (rum/cursor filters-atom (:key x))
                     {:class :tablesorter-filter})])
                headers))]

           cleaned-data
           (->>
             data
             (filtering-fn)
             (sorting-fn)
             (formatting-fn))

           pagecount
           (u/ceil
             (/
               (count cleaned-data)
               (:pagesize pagination)))
           _
           (when (> (rum/react page-atom) pagecount)
             (reset! page-atom pagecount))]
       [:div
        [:table
         {:class (u/bem :oTable [:has-shadow] :tablesorter)}
         [:thead
          [:tr
           (map
             (fn [col]
               [:th.tablesorter-header
                {:align "center"
                 :on-click
                 #(do
                    (if (= @sort-key-atom (:key col))
                      (swap! order-atom
                        (fn [x]
                          (if (= x :desc)
                            :asc
                            :desc)))
                      (reset! sort-key-atom (:key col))))
                 :class
                 [(cond
                    (not (= (rum/react sort-key-atom) (:key col)))
                    :tablesorter-header

                    (= (rum/react order-atom) :desc)
                    :tablesorter-headerDesc

                    (= (rum/react order-atom) :asc)
                    :tablesorter-headerAsc)]
                 :style {:user-select "none"}}
                [:div.tablesorter-header-inner (:title col)]])
             headers)]]

         (conj
           (into
             [:tbody]
             (concat
               search-bars
               (paging-fn
                 cleaned-data))))]
        (when pagination?
          (orders/pagination-control pagination-atom pagecount))])))

(rum/defc table < rum/reactive
  [label headers data options]
  [:div
   (when label
     [:h2 {:class (u/bem :yc-heading [:medium])} label])
   (table-raw headers data options)])